(function () {
    function customizeJudgeMe() {
        const widget = document.querySelector('#judgeme_product_reviews');
        if (!widget) return;

        // Change title
        const title = widget.querySelector('.jdgm-rev-widg__title');
        if (title && title.textContent !== 'Reviews') {
            title.textContent = 'Reviews';
        }

        // Change rating text: "4.71 out of 5" -> "4.71"
        const rating = widget.querySelector('.jdgm-rev-widg__summary-average');
        if (rating) {
            const match = rating.textContent.match(/[\d.]+/);

            if (match && rating.dataset.cleaned !== 'true') {
                rating.textContent = match[0];
                rating.dataset.cleaned = 'true';
            }
        }

        const summaryText = widget.querySelector('.jdgm-rev-widg__summary-text');

        if (summaryText && !summaryText.dataset.modified) {
            const count = summaryText.textContent.match(/\d+/)?.[0];

            if (count) {
                summaryText.textContent = `${count} Ratings`;
                summaryText.dataset.modified = 'true';
            }
        }

        const summaryStars = widget.querySelector('.jdgm-rev-widg__summary-stars');

        if (
            summaryStars &&
            !summaryStars.querySelector('.custom-stars-wrapper')
        ) {
            const ratingSpan = summaryStars.querySelector(
                '.jdgm-rev-widg__summary-average'
            );

            if (ratingSpan) {
                const stars = Array.from(summaryStars.querySelectorAll('.jdgm-star'));

                const starsWrapper = document.createElement('div');
                starsWrapper.className = 'custom-stars-wrapper';

                stars.forEach(star => starsWrapper.appendChild(star));

                summaryStars.innerHTML = '';

                summaryStars.appendChild(ratingSpan);
                summaryStars.appendChild(starsWrapper);
            }
        }

        const rowStars = widget.querySelector('.jdgm-row-stars');
        const actionsWrapper = widget.querySelector('.jdgm-widget-actions-wrapper');

        if (
            rowStars &&
            actionsWrapper &&
            !actionsWrapper.dataset.moved
        ) {
            rowStars.insertAdjacentElement('afterend', actionsWrapper);

            actionsWrapper.dataset.moved = 'true';
        }

        const histogramRows = widget.querySelectorAll('.jdgm-histogram__row[data-rating]');

        histogramRows.forEach((row) => {
            if (row.dataset.customized) return;

            const rating = row.dataset.rating;
            const frequencyEl = row.querySelector('.jdgm-histogram__frequency');

            if (!frequencyEl || rating === 'null') return;

            // Create rating label (5★, 4★, etc.)
            const ratingLabel = document.createElement('div');
            ratingLabel.className = 'custom-rating-label';
            ratingLabel.innerHTML = `<strong>${rating}.0</strong>`;
            // Insert before frequency
            frequencyEl.parentNode.insertBefore(ratingLabel, frequencyEl);

            // Convert frequency to "5 reviews"
            const count = frequencyEl.textContent.trim();

            frequencyEl.innerHTML = `
      <span class="custom-review-count">${count}</span>
      <span class="custom-review-text"> reviews</span>
    `;

            row.dataset.customized = 'true';
        });

        const reviewHeaders = widget.querySelectorAll('.jdgm-rev__header');

        reviewHeaders.forEach((header) => {
            if (header.dataset.ratingCustomized) return;

            const rowRating = header.querySelector('.jdgm-row-rating');
            const rowProfile = header.querySelector('.jdgm-row-profile');

            const rating = rowRating?.querySelector('.jdgm-rev__rating');
            const timestamp = rowRating?.querySelector('.jdgm-rev__timestamp');

            if (!rowProfile || !rating || !timestamp) return;

            // Create rating wrapper
            const ratingWrapper = document.createElement('div');
            ratingWrapper.className = 'custom-review-rating';

            const score = rating.getAttribute('data-score') || '0';

            const scoreEl = document.createElement('span');
            scoreEl.className = 'custom-review-score';
            scoreEl.textContent = score;

            ratingWrapper.appendChild(scoreEl);
            ratingWrapper.appendChild(rating);

            rowProfile.appendChild(timestamp);
            rowProfile.appendChild(ratingWrapper);

            header.dataset.ratingCustomized = 'true';
        });

        const summaryInner = document.querySelector('.jdgm-rev-widg__summary-inner');

        if (
            summaryInner &&
            !summaryInner.querySelector('.mobile-summary-meta')
        ) {
            const average = summaryInner.querySelector('.jdgm-rev-widg__summary-average');
            const stars = summaryInner.querySelector('.custom-stars-wrapper');
            const text = summaryInner.querySelector('.jdgm-rev-widg__summary-text');

            if (average && stars && text) {
                const meta = document.createElement('div');
                meta.className = 'mobile-summary-meta';

                meta.appendChild(stars);
                meta.appendChild(text);

                average.insertAdjacentElement('afterend', meta);
            }
        }

        if (window.innerWidth <= 749) {
            widget.querySelectorAll('.custom-review-rating .jdgm-rev__rating').forEach((rating) => {
                if (rating.dataset.singleStarApplied) return;

                rating.querySelectorAll('.jdgm-star').forEach((star, index) => {
                    if (index > 0) star.remove();
                });

                rating.dataset.singleStarApplied = 'true';
            });
        }

        // Apply custom layout once
        if (widget.dataset.customized) return;

        const header = widget.querySelector('.jdgm-rev-widg__header');
        const reviewsBody = widget.querySelector('.jdgm-rev-widg__body');

        if (!header || !reviewsBody) return;

        widget.dataset.customized = 'true';
        widget.classList.add('custom-review-layout');

        const wrapper = document.createElement('div');
        wrapper.className = 'custom-review-wrapper';

        header.parentNode.insertBefore(wrapper, header);

        wrapper.appendChild(header);
        wrapper.appendChild(reviewsBody);
    }

    // Initial run
    customizeJudgeMe();

    // Re-run when Judge.me updates
    const observer = new MutationObserver(() => {
        customizeJudgeMe();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();